import React from "react";
import "./Instructions.css";

function Instructions() {
	return (
		<div className="instructions">
			<h2>How to Use</h2>
			<ol>
				<li>Enter all the letters available</li>
				<li>
					Enter the pattern of the word. Use underscore for a blank.
					Ignore the size when entering a pattern.
				</li>
				<li>
					Enter the number of letters in the word when there is no
					pattern (ie. no letters are known).
				</li>
			</ol>
		</div>
	);
}

export default React.memo(Instructions);
